module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-port clearfix",
    attrs: {
      "id": "alerts"
    }
  }, [_c('div', {
    staticClass: "view bg-white"
  }, [_c('div', {
    staticClass: "navbar navbar-default navbar-sm"
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('a', {
    staticClass: "inline action p-l-10 link text-master",
    attrs: {
      "href": "javascript:;",
      "data-navigate": "view",
      "data-view-port": "#chat",
      "data-view-animation": "push-parrallax"
    }
  }, [_c('i', {
    staticClass: "pg-more"
  })]), _vm._v(" "), _c('div', {
    staticClass: "view-heading"
  }, [_vm._v("\n          Notications\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "inline action p-r-10 pull-right link text-master",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "pg-search"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "list-view boreded no-top-border",
    attrs: {
      "data-init-list-view": "ioslist"
    }
  }, [_c('div', {
    staticClass: "list-view-group-container"
  }, [_c('div', {
    staticClass: "list-view-group-header text-uppercase"
  }, [_vm._v("\n          Calendar\n        ")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "alert-list"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;",
      "data-navigate": "view",
      "data-view-port": "#chat",
      "data-view-animation": "push-parrallax"
    }
  }, [_c('p', {
    staticClass: "col-xs-height col-middle"
  }, [_c('span', {
    staticClass: "text-warning fs-10"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p-l-10 col-xs-height col-middle col-xs-9 overflow-ellipsis fs-12"
  }, [_c('span', {
    staticClass: "text-master"
  }, [_vm._v("David Nester Birthday")])]), _vm._v(" "), _c('p', {
    staticClass: "p-r-10 col-xs-height col-middle fs-12 text-right"
  }, [_c('span', {
    staticClass: "text-warning"
  }, [_vm._v("Today "), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "text-master"
  }, [_vm._v("All Day")])])])]), _vm._v(" "), _c('li', {
    staticClass: "alert-list"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "data-navigate": "view",
      "data-view-port": "#chat",
      "data-view-animation": "push-parrallax"
    }
  }, [_c('p', {
    staticClass: "col-xs-height col-middle"
  }, [_c('span', {
    staticClass: "text-warning fs-10"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p-l-10 col-xs-height col-middle col-xs-9 overflow-ellipsis fs-12"
  }, [_c('span', {
    staticClass: "text-master"
  }, [_vm._v("Meeting at 2:30")])]), _vm._v(" "), _c('p', {
    staticClass: "p-r-10 col-xs-height col-middle fs-12 text-right"
  }, [_c('span', {
    staticClass: "text-warning"
  }, [_vm._v("Today")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "list-view-group-container"
  }, [_c('div', {
    staticClass: "list-view-group-header text-uppercase"
  }, [_vm._v("\n          Social\n        ")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "alert-list"
  }, [_c('a', {
    staticClass: "p-t-10 p-b-10",
    attrs: {
      "href": "javascript:;",
      "data-navigate": "view",
      "data-view-port": "#chat",
      "data-view-animation": "push-parrallax"
    }
  }, [_c('p', {
    staticClass: "col-xs-height col-middle"
  }, [_c('span', {
    staticClass: "text-complete fs-10"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p-l-10 col-xs-height col-middle col-xs-12 overflow-ellipsis fs-12"
  }, [_c('span', {
    staticClass: "text-master link"
  }, [_vm._v("Jame Smith commented on your status"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "text-master"
  }, [_vm._v("“Perfection Simplified - Company Revox\"")])])])]), _vm._v(" "), _c('li', {
    staticClass: "alert-list"
  }, [_c('a', {
    staticClass: "p-t-10 p-b-10",
    attrs: {
      "href": "javascript:;",
      "data-navigate": "view",
      "data-view-port": "#chat",
      "data-view-animation": "push-parrallax"
    }
  }, [_c('p', {
    staticClass: "col-xs-height col-middle"
  }, [_c('span', {
    staticClass: "text-complete fs-10"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p-l-10 col-xs-height col-middle col-xs-12 overflow-ellipsis fs-12"
  }, [_c('span', {
    staticClass: "text-master link"
  }, [_vm._v("Jame Smith commented on your status"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "text-master"
  }, [_vm._v("“Perfection Simplified - Company Revox\"")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "list-view-group-container"
  }, [_c('div', {
    staticClass: "list-view-group-header text-uppercase"
  }, [_vm._v("\n          Sever Status\n        ")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "alert-list"
  }, [_c('a', {
    staticClass: "p-t-10 p-b-10",
    attrs: {
      "href": "#",
      "data-navigate": "view",
      "data-view-port": "#chat",
      "data-view-animation": "push-parrallax"
    }
  }, [_c('p', {
    staticClass: "col-xs-height col-middle"
  }, [_c('span', {
    staticClass: "text-danger fs-10"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p-l-10 col-xs-height col-middle col-xs-12 overflow-ellipsis fs-12"
  }, [_c('span', {
    staticClass: "text-master link"
  }, [_vm._v("12:13AM GTM, 10230, ID:WR174s"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "text-master"
  }, [_vm._v("Server Load Exceeted. Take action")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2fb73cc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/alerts.vue
// module id = 1354
// module chunks = 1